{{#if asModalDialog}}
<div class="modal-header">
	<button type="button" class="close" data-dismiss="modal">×</button>
	<h4 class="modal-title">{{TYPE_GATEWAY type}} - {{TR "Einstellungen"}}</h4>
</div>
<div class="modal-body">
{{else}}
	<div class="row m-t-20 p-l-r-10">
		<div class="col-xs-12 col-sm-4">
			<center><img class="clamp-width-500 p-10" src="../img/devices/gateway_{{type}}_large.png" /></center>
		</div>
		<div class="col-xs-12 col-sm-8">
			<div class="row">
				<dl class="dl-horizontal">
					<dt>{{TR "Typ"}}</dt>
					<dd>{{TYPE_GATEWAY type}}</dd>
					<div class="m-t-15">
						<dt>{{TR "MAC-Adresse"}}</dt>
						<dd>{{mac_address}}</dd>
					</div>
					<div class="m-t-15">
						<dt>{{TR "Seriennummer"}}</dt>
						<dd>{{serial}}</dd>
						<dt>{{TR "Firmware"}}</dt>
						<dd>{{firmware}}</dd>
					</div>
					<div class="m-t-15">
						<dt>{{TR "Angemeldet seit"}}</dt>
						<dd>{{TIME registered}}</dd>
					</div>
				</dl>
			</div>
		</div>
	</div>
	<div class="row m-t-20">
		<div class="col-xs-12">
{{/if}}
	{{#if errors.error}}
		<div class="alert alert-danger">
			{{TR errors.error}}
			{{#if errors.sysErr}}
			 ({{ERROR_TR errors.sysErr}})
			{{/if}}
		</div>
	{{/if}}
	<div class="row" id="devicename_form">
		<div class="col-xs-12">
			{{#unless asModalDialog}}<p>{{TR "Bitte tragen Sie eine Bezeichnung für Ihr neu angeschlossenes Gerät ein."}}</p>{{/unless}}
			<div class="form-group">
				<label for="devicename" class="control-label">{{TR "Gerätename"}}</label>
				<input type="text" class="form-control {{#if errors.name}}parsley-error{{/if}}" id="name-input" name="devicename" placeholder="{{TR "Gerätename"}}" value="{{name}}" maxlength="100">
				{{#if errors.name}}
				<ul class="parsley-errors-list filled" id="js-devicename-error">
					<li class="parsley-required">{{TR "Name ist"}} {{TR errors.name}}</li>
				</ul>
				{{/if}}
			</div>
		</div>
	</div>
{{#if asModalDialog}}
</div>
<div class="modal-footer">
	<button id="ct-cancel" type="button" class="btn btn-white" data-dismiss="modal">{{TR "Abbrechen"}}</button>
	<button class="btn btn-primary" id="js-success">{{TR "Speichern"}}</button>
</div>
{{else}}
	<div class="row" id="replacement_select_form">
		<div class="col-sm-8">
			<div class="form-group">
				<label for="replacement_select" class="control-label">
					<span id="replacement_select_hint">({{TR "Optional"}})</span>
					{{TR "Ersetzt folgendes Gerät"}}
				</label>
				{{#DEVICE_SELECT replacement_select}}
				<select class="form-control" id="replacement_select-input" name="replacement_select">
				</select>
				{{/DEVICE_SELECT}}
			</div>
		</div>
		<div class="col-sm-4">
			<div class="form-group">
				<label class="control-label hidden-xs">&nbsp;</label>
				<button id="js-check-replacement" type="button" class="btn btn-white full-width disabled" disabled="true">{{TR "Prüfen"}}</button>
			</div>
		</div>
	</div>
</div>
{{/if}}
